import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EnvService } from './env.service';
import { ToastService } from '../toastr';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    public offsetWidth = document.body.offsetWidth;
    constructor(
        private http: HttpClient,
        private router: Router,
        private env: EnvService,
        private toastr: ToastService) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUserDetails')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }

    login(loginCredential) {
        let headersOptions: HttpHeaders = new HttpHeaders();
        headersOptions = headersOptions.append('Accept', 'application/json');
        headersOptions = headersOptions.append('Content-Type', 'application/json');
        headersOptions = headersOptions.append('username', loginCredential.username);
        headersOptions = headersOptions.append('password', loginCredential.password);
        headersOptions = headersOptions.append('mode', 'W');
        return this.http.post<any>(this.env.apiUrl + 'loginservice/login', {}, { headers: headersOptions })
            .pipe(map(user => {
                if (user.statusCode === "200") {
                    localStorage.setItem('currentUserDetails', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    return user;
                } else {
                    return user;
                }
            }));
    }

    get isLoggedIn() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return true;
        } else {
            return false;
        }
    }

    get activeToken() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].token;
        } else {
            return null;
        }
    }

    get companyID() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].companyID;
        } else {
            return null;
        }
    }

    get employeeID() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].empID;
        } else {
            return null;
        }
    }
    get employeeName() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].employeeName;
        } else {
            return null;
        }
    }

    get pageSize() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            if (this.offsetWidth <= 900) {
                return loggedInUser.responseList[0].mPageSize === null ? 10 : loggedInUser.responseList[0].mPageSize;
            } else {
                return loggedInUser.responseList[0].pageSize === null ? 100 : 30;
            }
        } else {
            return null;
        }
    }

    get periodOfDays() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].noOfDays;
        } else {
            return 7;
        }
    }

    get menuList() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].menus;
        } else {
            return [];
        }
    }

    get dateRangeLimit() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].dateRangeLimit;
        } else {
            return 90;
        }
    }

    get employeeRole() {
        const loggedInUser = this.currentUserValue;
        if (loggedInUser !== null && loggedInUser.statusCode === "200") {
            return loggedInUser.responseList[0].roleList[0];
        } else {
            return 0;
        }
    }

    get randomErrorForAPIFallback(): string {
        return 'Please check your internet connection and try again!'
    }

    changePassword(payload): Observable<any[]> {
        let headersOptions: HttpHeaders = new HttpHeaders();
        headersOptions = headersOptions.append('Accept', 'application/json');
        headersOptions = headersOptions.append('Content-Type', 'application/json')
        return this.http.post<any[]>(this.env.apiUrl + 'auth/change-password', payload, { headers: headersOptions })
    }

    logout() {
        this.toastr.show({ type: 'success', text: 'Successfully Logged out!' });
        // remove user from local storage to log user out
        localStorage.clear();
        this.currentUserSubject.next(null);
        this.router.navigate(['/auth']);
    }
}
